import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../core/store';

const Spinner: React.FC = () => {
  const {
    common: { isEnabledSpinner },
  } = useSelector((state: AppState) => state);

  return (
    <>
      {isEnabledSpinner && (
        <div className={'container-loading'}>
          <div className={'loader'} />
        </div>
      )}
    </>
  );
};

export default Spinner;
